import { Component, OnInit } from '@angular/core';
import { FilterSettings } from '../projects/project-filters/filter-settings';
import { cleanDescription, formatDate, shippedColor } from './shared';

@Component({
  selector: 'master-schedule',
  templateUrl: './master-schedule.component.html',
  styleUrls: ['./master-schedule.component.scss'],
  standalone: false
})
export class MasterScheduleComponent implements OnInit {

  constructor() { }

  public readonly defaultActivityFilter: string = 'Order Entry;Engineering;Production';

  public shippedColor = shippedColor;
  public cleanDescription = cleanDescription;
  public formatDate = formatDate;

  public projects: any[] = [];
  public selectedProject: any = null;

  public selectionRowId: number | null = null;
  public selectionStartDate: Date | null = null;
  public selectionEndDate: Date | null = null;

  public updating: boolean = false;
  public lastBackendUpdate: Date | null = null;
  public backendCheckVisible: boolean = false;

  public contextRowId: number | null = null;
  public contextMenuVisible: boolean = false;
  public contextMenuPosition = { x: 0, y: 0 };
  public contextActivity: any = null;

  public activityHistoryVisible: boolean = false;
  public activityHistoryData: any[] = [];

  public filterSettings: FilterSettings = new FilterSettings();
  public filterSettingsLastUpdated: Date = new Date(0);
  public readonly updateProjectsCallback: () => void = this.updateProjects.bind(this);

  ngOnInit(): void {
    try {
      const stored = localStorage.getItem("masterScheduleFilterSettings");
      if (stored) {
        const parsed = JSON.parse(stored) as FilterSettings;
        Object.assign(this.filterSettings, parsed);
        this.normalizeFilterDates();
      }
    } catch {
      // Ignore bad settings
    }

    if (!this.filterSettings.activity || !this.filterSettings.activity.trim()) {
      this.filterSettings.activity = this.defaultActivityFilter;
    }

    // Master Schedule page defaults to weekly calendar mode.
    this.filterSettings.showWeeks = true;
    this.filterSettings.startAtToday = true;
    this.filterSettings.dayRangeMin = -104;
    this.filterSettings.dayRangeMax = 104;
    this.filterSettings.selectedDay = 0;

    this.updateProjects();
  }

  isSelectedProject(project: any): boolean {
    return this.selectedProject && project.ProjectNumber === this.selectedProject.ProjectNumber;
  }

  dayRangeChanged() { 
    this.filterSettings.dayRangeChanged?.();
  }

  startAtChanged() {
    this.filterSettings.startAtChanged?.();
  }



  updateProjects() { 
    if (!this.filterSettings.activity || !this.filterSettings.activity.trim()) {
      this.filterSettings.activity = this.defaultActivityFilter;
    }

    this.filterSettingsLastUpdated = new Date();
  }

  private normalizeFilterDates() {
    const toDateOrNull = (value: unknown): Date | null => {
      if (!value) {
        return null;
      }

      const parsed = value instanceof Date ? value : new Date(value as string);
      return Number.isNaN(parsed.getTime()) ? null : parsed;
    };

    this.filterSettings.poStartDate = toDateOrNull(this.filterSettings.poStartDate);
    this.filterSettings.poEndDate = toDateOrNull(this.filterSettings.poEndDate);
    this.filterSettings.shipStartDate = toDateOrNull(this.filterSettings.shipStartDate);
    this.filterSettings.shipEndDate = toDateOrNull(this.filterSettings.shipEndDate);

    const normalizedStartDate = toDateOrNull(this.filterSettings.startDate);
    if (normalizedStartDate) {
      this.filterSettings.startDate = normalizedStartDate;
    }
  }



  buildFilterCommandParams(): string {
    const params = new URLSearchParams();
    
    if (this.filterSettings.product) params.append('product', this.filterSettings.product);
    if (this.filterSettings.project) params.append('project', this.filterSettings.project);
    if (this.filterSettings.endUser) params.append('endUser', this.filterSettings.endUser);
    if (this.filterSettings.customer) params.append('customer', this.filterSettings.customer);
    if (this.filterSettings.poNumber) params.append('poNumber', this.filterSettings.poNumber);
    if (this.filterSettings.salesManager) params.append('salesManager', this.filterSettings.salesManager);
    if (this.filterSettings.technicalEngineer) params.append('technicalEngineer', this.filterSettings.technicalEngineer);
    if (this.filterSettings.projectManager) params.append('projectManager', this.filterSettings.projectManager);
    if (this.filterSettings.planner) params.append('planner', this.filterSettings.planner);
    if (this.filterSettings.mechanicalEngineer) params.append('mechanicalEngineer', this.filterSettings.mechanicalEngineer);
    if (this.filterSettings.mechanicalDrafter) params.append('mechanicalDrafter', this.filterSettings.mechanicalDrafter);
    if (this.filterSettings.electricalEngineer) params.append('electricalEngineer', this.filterSettings.electricalEngineer);
    if (this.filterSettings.electricalDrafter) params.append('electricalDrafter', this.filterSettings.electricalDrafter);
    if (this.filterSettings.activity) params.append('activity', this.filterSettings.activity);
    if (this.filterSettings.status) params.append('status', this.filterSettings.status);
    
    return params.toString();
  }

}